module.exports = __webpack_public_path__ + "images/emoji/dvd.e0370a797cb4f8893bba.png";